import type { FaqSpace } from './types';

export const DEFAULT_FAQ_SPACE_SLUG = 'faq';

export function normalizeFaqSpaceSlug(slug?: string | null) {
  const normalized = (slug || DEFAULT_FAQ_SPACE_SLUG).trim().toLowerCase();
  return normalized || DEFAULT_FAQ_SPACE_SLUG;
}

export function isFaqSpaceLikeSlug(slug?: string | null) {
  const normalized = normalizeFaqSpaceSlug(slug);
  return normalized === DEFAULT_FAQ_SPACE_SLUG || normalized.endsWith('-faq');
}

export function isFaqSpaceLikePath(pathname: string) {
  const firstSegment = pathname.split('/').filter(Boolean)[0];
  return isFaqSpaceLikeSlug(firstSegment);
}

function normalizeSubPath(path?: string) {
  if (!path) return '';
  return path.replace(/^\/+/, '').replace(/\/+$/, '');
}

export function buildFaqPath(spaceOrSlug: Pick<FaqSpace, 'slug'> | string, path?: string) {
  const slug = typeof spaceOrSlug === 'string' ? spaceOrSlug : spaceOrSlug.slug;
  const basePath = `/${normalizeFaqSpaceSlug(slug)}`;
  const subPath = normalizeSubPath(path);
  return subPath ? `${basePath}/${subPath}` : basePath;
}

export function buildFaqAdminPath(spaceOrSlug: Pick<FaqSpace, 'slug'> | string, path?: string) {
  const subPath = normalizeSubPath(path);
  return buildFaqPath(spaceOrSlug, subPath ? `uadmin/${subPath}` : 'uadmin');
}
